import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { CityRoute } from "./routes/CityRoute.js";
import { InstallPrompt } from "./components/InstallPrompt.js";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:citySlug/*" element={<CityRoute />} />
        <Route
          path="/"
          element={
            <div style={{ padding: "var(--s-6)", textAlign: "center" }}>
              <h1 style={{ fontFamily: "var(--f-display)" }}>Паспорт искателя</h1>
              <p>
                Отсканируйте QR на монете, чтобы открыть паспорт своего города.
              </p>
            </div>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <InstallPrompt />
    </BrowserRouter>
  );
}
